import React, { memo, FC } from 'react'
import Icon from 'components/Icon'
import { VERSION } from 'constants/App'
import styles from './style.module.css'

type Props = {
  warehouseName: string
  tenantName: string
}

const BookingWorkRecordHeader: FC<Props> = ({ warehouseName, tenantName }) => {
  return (
    <header className={styles.header}>
      <div className={styles.brand}>
        <Icon src="/assets/svgs/monoful-brand-white.svg" width="85px" height='auto' alt="hacobell brand" className={styles.brandLogo} />
        <Icon src="/assets/svgs/hacobell-brand-foreground-white.svg" width="120px" height='auto' alt="ハコベル トラック簿" className={styles.brandLogoSp} />
        <p className={styles.brandText}>トラック簿</p>
      </div>

      <div className={styles.main}>
        <div className={styles.names}>
          {warehouseName && <span className={styles.warehouseName}>{warehouseName}</span>}
          {warehouseName && tenantName && <span>|</span>}
          {tenantName && <span className={styles.tenantName}>{tenantName}</span>}
        </div>
        <div className={styles.titleSection}>
          受付入力
          <span className={styles.version}>ver. tf{VERSION}</span>
        </div>
      </div>
    </header>
  )
}

export default memo(BookingWorkRecordHeader)
